import { useEffect } from 'react';
import { useSubscription } from '@apollo/client';

import type {
  GetCurrentActivitiesEditorsSubscription,
  GetCurrentActivitiesEditorsSubscriptionVariables,
} from '../../lesson-builder.graphql.generated';
import { ActivitiesContentType } from 'global/constants';
import { GET_CURRENT_ACTIVITIES_EDITORS_SUBSCRIPTION } from '../../lesson-builder.graphql';
import { activityBuilderEditors } from './activity-builder-editors.apollo';
import { processActivityEditorsUpdate } from './logic/process-activity-editors';

export const useCurrentActivitiesEditorsSubscription = (
  contentId: number,
  contentType: ActivitiesContentType
) => {
  const data = useSubscription<
    GetCurrentActivitiesEditorsSubscription,
    GetCurrentActivitiesEditorsSubscriptionVariables
  >(GET_CURRENT_ACTIVITIES_EDITORS_SUBSCRIPTION, {
    variables: {
      input: {
        contentId,
        contentType,
      },
    },
    shouldResubscribe: true,
    skip: !contentId || !contentType,
    onData: ({ data: pushedUpdate }) => {
      const editors = pushedUpdate?.data?.getCurrentActivitiesEditors;
      processActivityEditorsUpdate(
        editors,
        () => activityBuilderEditors(),
        newEditors => activityBuilderEditors(newEditors)
      );
    },
  });

  // Cleanup when component unmounts or dependencies change
  useEffect(() => {
    return () => {
      activityBuilderEditors([]);
    };
  }, [contentId, contentType]);

  return data;
};
